import { Capacitor } from '@capacitor/core'

export const isNativePlatform = () => Capacitor.isNativePlatform()

export const requireNativePlatform = (feature: string): void => {
  if (!isNativePlatform()) {
    throw new Error(`${feature} is only available in the native AROYA app.`)
  }
}
